import React, { FC } from 'react';
import {
  ActivityLogLayout,
  JournalSectionSkeleton,
  TradesTableSectionSkeleton,
} from './components';

export const ActivityLogLoading: FC = () => {
  return (
    <ActivityLogLayout>
      <TradesTableSectionSkeleton />
      <JournalSectionSkeleton />
    </ActivityLogLayout>
  );
};
